import { useQuery } from '@hooks/reactQuery';

import { getAllOrganizations } from '@api/organisations';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IOrganisationEntity } from '@interfaces/organisation/organisations';

import { EUserRoles } from '@enums/common';

import { ORGANISATIONS } from '@constants/queryKeys';

export const useQueryAllOrganisations = (
	optionsFormatter?: (data: IOrganisationEntity[]) => TSelectOption<string>[],
) => {
	const { data: organisationsAll } = useQuery<Array<IOrganisationEntity>>({
		queryKey: [ORGANISATIONS],
		queryFn: getAllOrganizations,
		select: (items) => {
			return items.sort((a, b) => a?.name?.localeCompare(b?.name));
		},
		refetchOnWindowFocus: false,
		allowedRoles: [EUserRoles.platformOwnerAdministrator],
	});

	return {
		organisationsAll: organisationsAll || [],
		formattedOrganisations: optionsFormatter && organisationsAll ? optionsFormatter(organisationsAll) : [],
	};
};
